import { FOBookingOptionsListAllPropertiesObjectInterface } from '@modules/front-office/interface/fo-api-interface';
import { createSlice, PayloadAction } from '@reduxjs/toolkit';

const initialState: FOBookingOptionsListAllPropertiesObjectInterface = {
  property: {
    tenantID: '',
    propertyID: '',
    marketSegment: [],
    VIPLevels: [],
    salutations: [],
    sub_folios: [],
  },
};

export const FOBookingOptionListSlice = createSlice({
  name: 'foBookingOptionList',
  initialState,
  reducers: {
    setBookingOptionList: (
      state,
      action: PayloadAction<FOBookingOptionsListAllPropertiesObjectInterface>,
    ) => {
      return { ...state, ...action.payload };
    },
    removeBookingOptionList: () => {
      return initialState;
    },
  },
});

export default FOBookingOptionListSlice.reducer;

export const { setBookingOptionList, removeBookingOptionList } =
  FOBookingOptionListSlice.actions;
